import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "left",
  "use": "left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"left\"><defs><style></style></defs><path d=\"M394.88 512l294.592-330.688a32 32 0 10-47.744-42.624l-313.6 352a32 32 0 000 42.624l313.6 352a32 32 0 1047.744-42.624L394.88 512z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol